class GetSiteVersionNumber {
    static url = "https://api.github.com/repos/gokacinlar/portfolio/tags";
    _version = "Loading...";
    async fetchPhpFile(targetUrl) {
        try {
            const response = await fetch(targetUrl, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            console.error("Fetch error:", error);
            throw error;
        }
    }
    async scrape() {
        const data = await this.fetchPhpFile(GetSiteVersionNumber.url);
        if (data && data.length > 0 && data[0].name) {
            const result = data[0].name;
            this.addVersionNumberToLocalStorage(result);
            return result;
        }
        else {
            return "N/A";
        }
    }
    addVersionNumberToLocalStorage(data) {
        try {
            const localStorageKeyId = "version-number";
            const currentStoredVersion = localStorage.getItem(localStorageKeyId);
            ;
            if (data !== currentStoredVersion) {
                localStorage.setItem(localStorageKeyId, data);
            }
        }
        catch (error) {
            console.error(`Unable to add site version number to local storage: ${error}`);
        }
    }
    getSiteVersionFromLocalStorage() {
        try {
            const targetKey = "version-number";
            const storedVersion = localStorage.getItem(targetKey);
            if (!storedVersion) {
                return "N/A";
            }
            return storedVersion;
        }
        catch (error) {
            console.error(`Unable to get site version number from the local storage: ${error}`);
            return "N/A";
        }
    }
    get version() {
        return this._version;
    }
    set version(version) {
        this._version = version;
    }
    async init() {
        this._version = await this.scrape();
    }
}
export default GetSiteVersionNumber;
